// extracted by mini-css-extract-plugin
export default {"buttons":"JobPlacementCard_buttons__ESNab"};